<a href="#cursos" class="p-d-none p-d-md-block">
  <p-carousel id="banners" [value]="banner" [autoplayInterval]="6500" [circular]="true" [showIndicators]="false"
    [showNavigators]="true">
    <ng-template class="p-p-0 p-m-0" let-banner pTemplate="item">
      <div class="p-mb-3">
        <div *ngIf="banner.image != ''">
          <img width="100%" style="min-height: 400px; max-height: 600px; object-fit:cover; object-position: 0%;" src="{{banner.image}}" [alt]="banner.name" />
        </div>
        <div *ngIf="banner.image == ''" class="bg-azul" style="height: 600px; width: 100%;">
        </div>
      </div>
    </ng-template>
  </p-carousel>
</a>